import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5602bbe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PieEchart = _resolveComponent("PieEchart")!
  const _component_ZpCard = _resolveComponent("ZpCard")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_MapEchart = _resolveComponent("MapEchart")!
  const _component_RoseEchart = _resolveComponent("RoseEchart")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_LineEchart = _resolveComponent("LineEchart")!
  const _component_BarEchart = _resolveComponent("BarEchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 10 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 7 }, {
          default: _withCtx(() => [
            _createVNode(_component_ZpCard, { title: "分类商品数量(饼图)" }, {
              default: _withCtx(() => [
                _createVNode(_component_PieEchart, { pieData: _ctx.categoryGoodsCount }, null, 8, ["pieData"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_ZpCard, { title: "不同城市商品销量" }, {
              default: _withCtx(() => [
                _createVNode(_component_MapEchart, { mapData: _ctx.addressGoodsSale }, null, 8, ["mapData"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 7 }, {
          default: _withCtx(() => [
            _createVNode(_component_ZpCard, { title: "分类商品数量(玫瑰图)" }, {
              default: _withCtx(() => [
                _createVNode(_component_RoseEchart, { roseData: _ctx.categoryGoodsCount }, null, 8, ["roseData"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      gutter: 10,
      class: "content-row"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_ZpCard, { title: "分类商品销量" }, {
              default: _withCtx(() => [
                _createVNode(_component_LineEchart, _normalizeProps(_guardReactiveProps(_ctx.categoryGoodsSale)), null, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_ZpCard, { title: "分类商品的收藏" }, {
              default: _withCtx(() => [
                _createVNode(_component_BarEchart, _normalizeProps(_guardReactiveProps(_ctx.categoryGoodsSale)), null, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}